import { Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CraftType } from '../../../../../../shared/src';
import { CraftEntity } from '../../../models/craft-entity.model';

@Component({
  selector: 'lib-product-crafts-preview-card',
  imports: [NgbDropdownModule, NgSelectModule],
  templateUrl: './product-crafts-preview-card.component.html',
  styleUrl: './product-crafts-preview-card.component.scss'
})
export class ProductCraftsPreviewCardComponent {
  craftEntity = input<CraftEntity>();
  CraftTypeEnum = CraftType;
  openCraftModal = output<string>();
}
